import * as React from 'react';
import { connect } from 'react-redux';

const Error = () => (
    <div className="container-fluid h-100" style={{ background: '#29375f', color: '#fff' }}>
        <div className="container h-100">
            <div className="row h-100">
                <div className="col-12 my-auto text-center">
                    <h1>Please contact CMS_L3@Dell.com for Access!</h1>
                    <div><span style={{ fontSize: '16px', fontWeight: 500, fontStyle: 'italic' }}>Powered by StudioD Connect</span></div>
                </div>
            </div>
        </div>
    </div >
);

export default connect()(Error);
